<template lang="html">
  <HeaderNavContent>
    <NavButtons v-if="isMobile">
      <li class="nav-button-item">
        <router-link :to="prevRoute">Back</router-link>
      </li>
    </NavButtons>

    <template v-else>
      <AppLogo />
      <NavHamburger />
    </template>
  </HeaderNavContent>
</template>

<script>
import AppLogo from '@/components/AppLogo';
import HeaderNavContent from '@/components/HeaderNavContent';
import NavHamburger from '@/components/NavHamburger';
import NavButtons from '@/components/NavButtons';
import mobileDetection from '@/mixins/mobile-detection';

export default {
  name: 'HeaderNavDefault',

  components: {
    AppLogo,
    HeaderNavContent,
    NavHamburger,
    NavButtons,
  },

  mixins: [mobileDetection],

  props: {
    prevRoute: {
      type: Object,
      required: true,
    },
  },
};
</script>
